import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';
import ContactImg from '../img/contact/contactimg.png';
import emailjs from 'emailjs-com'; // Import EmailJS

const ContactUs = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_3epr048', // Replace with your EmailJS service ID
        'template_wev4fr7', // Replace with your EmailJS template ID
        form.current,
        'hZ8qT32X43kgAz-5I' // Replace with your EmailJS user ID (or public key)
      )
      .then(
        (result) => {
          console.log(result.text);
          alert('Message sent successfully!');
        },
        (error) => {
          console.log(error.text);
          alert('Failed to send the message. Please try again.');
        }
      );

    e.target.reset(); // Reset form fields after submission
  };

  return (
    <section id="contact" className="py-16 bg-[#f9f9f9]">
      <div className="container mx-auto flex flex-col lg:flex-row items-center justify-between gap-12">
        {/* Left side - Image */}
        <motion.div
          variants={fadeIn('left')}
          initial="hidden"
          whileInView={'show'}
          viewport={{ once: false, amount: 0.6 }}
          className="flex-1"
        >
          <img
            src={ContactImg}
            alt="After the Fallout"
            className="w-full h-auto object-cover rounded-md"
          />
        </motion.div>

        {/* Right side - Contact Info and Form */}
        <motion.div
          variants={fadeIn('right')}
          initial="hidden"
          whileInView={'show'}
          viewport={{ once: false, amount: 0.6 }}
          className="flex-1"
        >
          <h2 className="h2 mb-6 max-w-[400px] lg:max-w-none lg:w-full mx-auto text-center lg:text-left">
            Contact Us:
          </h2>
          <div className="mb-8">
            <h3 className="text-lg font-semibold mb-2">Holiday, FL</h3>
            <p className="text-grey mb-4">
              In MT. Vernon Center in the north building.
            </p>
            <div className="text-grey">
              <p className="mb-2">
                📍 2238 US-19, Holiday, FL 34690
              </p>
              <p className="mb-2">
                📞 727.940.5580
              </p>
              <p className="mb-2">
                ✉️ Tajohnson09301979@gmail.com
              </p>
              <a 
                href="https://www.google.com/maps/dir//2238+US-19,+Holiday,+FL+34690/@28.1913849,-82.8217296,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x88c28d392819dad9:0x101f86be4e3c833e!2m2!1d-82.7393286!2d28.1913476?entry=ttu&g_ep=EgoyMDI0MTAyOS4wIKXMDSoASAFQAw%3D%3D"
                target="_blank" 
                rel="noopener noreferrer"
                className="text-grey-200 hover:underline"
              >
                Get location
              </a>
            </div>
          </div>

          {/* Contact Form */}
          <form ref={form} onSubmit={sendEmail} className="space-y-6">
            <input
              type="text"
              name="user_name" // Required for EmailJS template
              placeholder="Write your name here"
              className="w-full border-b border-gray-400 py-2 focus:outline-none"
              required
            />
            <input
              type="email"
              name="user_email" // Required for EmailJS template
              placeholder="Write your email address"
              className="w-full border-b border-gray-400 py-2 focus:outline-none"
              required
            />
            <textarea
              name="message" // Required for EmailJS template
              placeholder="Write your messages here"
              className="w-full border-b border-gray-400 py-2 focus:outline-none"
              rows="4"
              required
            />
            <button
              type="submit"
              className="btn btn-sm lg:btn-lg btn-outline bg-black text-white mt-4 hover:bg-gray-800"
            >
              SEND IT
            </button>
          </form>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactUs;
